export var isInFullScreen = function (state) { return state.player.state.isInFullScreen; };
export var isPlayerUIVisible = function (state) { return state.player.ui.isVisible; };
export var isMuted = function (state) { return state.player.state.muted; };
export var isVolumeChangedByUser = function (state) {
    return state.player.state.isVolumeChangedByUser;
};
export var isAutoplayed = function (state) { return state.player.state.autoPlayed; }; // TODO fix for lightbox
export var getOverlayContent = function (state) { return state.player.state.overlayContent; };
